export var ValuePhonetizationMethod;
(function (ValuePhonetizationMethod) {
    ValuePhonetizationMethod["Hangul"] = "Hangul";
    ValuePhonetizationMethod["Kana"] = "kana";
})(ValuePhonetizationMethod || (ValuePhonetizationMethod = {}));
//# sourceMappingURL=ValuePhonetizationMethod.js.map